import { useEffect } from 'react';

interface Params {
	unseenCount: number;
}

export default function useFeatureAnnouncementTriggerSideEffects({
	unseenCount,
}: Params) {
	// Switch between favicon and favicon with notification indicator.
	useEffect(() => {
		if (unseenCount > 0) {
			const faviconEl = document.querySelector(
				'head link[href="/favicon.svg"]'
			);

			faviconEl?.setAttribute('href', '/favicon-with-notification.svg');
		} else {
			const faviconWithNotificationEl = document.querySelector(
				'head link[href="/favicon-with-notification.svg"]'
			);

			faviconWithNotificationEl?.setAttribute('href', '/favicon.svg');
		}
	}, [unseenCount]);
}
